import { generateRandomString, pkceChallengeFromVerifier } from './functions';

export interface PKCEVerifier {
  loadVerifier(): Promise<string | null>;
  generateCodeChallenge(): Promise<string>;
}

export class SessionStoragePKCEVerifier implements PKCEVerifier {
  private readonly storageKey = 'pkce-verifier';

  async loadVerifier(): Promise<string | null> {
    if (sessionStorage) {
      return sessionStorage.getItem(this.storageKey);
    }
    return null;
  }

  generateCodeChallenge(): Promise<string> {
    const verifier = generateRandomString();
    if (sessionStorage) {
      sessionStorage.setItem(this.storageKey, verifier);
    }
    return pkceChallengeFromVerifier(verifier);
  }
}
